import React from 'react';
import PropTypes from 'prop-types';
import DetailsSkeleton, {
	DetailsSkeletonContainerClasses
} from '../skeleton/DetailsSkeleton';
import TitleSkeleton from '../skeleton/TitleSkeleton';
import VehicleTitle from './VehicleTitle';
import Details from './Details';

const DetailsContainer = ({
	shouldFullyRenderCard,
	isTabbedLayout,
	...props
}) => (
	<div
		className={`vehicle-card-details-container${
			!shouldFullyRenderCard
				? ` ${DetailsSkeletonContainerClasses.join(' ')}`
				: ''
		}`}
	>
		{props.vehicle ? (
			<VehicleTitle
				isTabbedLayout={isTabbedLayout}
				title={props.vehicle.title}
				link={props.vehicle.link}
				vehicleId={props.vehicle.uuid}
				condition={props.vehicle.condition}
			/>
		) : (
			<TitleSkeleton isTabbedLayout />
		)}
		{shouldFullyRenderCard ? (
			<Details {...props} isTabbedLayout={isTabbedLayout} />
		) : (
			<DetailsSkeleton isTabbedLayout={isTabbedLayout} />
		)}
	</div>
);

DetailsContainer.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		uuid: PropTypes.string,
		link: PropTypes.string,
		condition: PropTypes.string
	}),
	isTabbedLayout: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool,
	shouldFullyRenderCard: PropTypes.bool.isRequired
};

export default DetailsContainer;
